// @flow
import { CancelToken } from 'axios';
import { CANCEL } from 'redux-saga';
import { camelizeKeys } from 'humps';

import callApi from './callApi';
import type { CallApiConfig, ApiResponse } from './callApi';

export type CancelablePromise<T> = Promise<T> & {
  cancel: () => void,
};

const defaultHandler = async (apiPromise) => {
  const { data } = await apiPromise;

  return camelizeKeys(data);
};

export function cancelableCallApi<T>(
  config: CallApiConfig,
  handler?: (response: Promise<ApiResponse>) => Promise<T> = defaultHandler,
): CancelablePromise<T> {
  const source = CancelToken.source();

  const promise = callApi({
    preventDefaultErrorHandler: !config.withError,
    ...config,
    cancelToken: source.token,
  });

  const resultPromise = handler(promise);

  // $FlowFixMe
  resultPromise[CANCEL] = source.cancel;

  // $FlowFixMe
  return resultPromise;
}

export default cancelableCallApi;



// WEBPACK FOOTER //
// ./src/common/network/cancelableCallApi.js